import { render, staticRenderFns } from "./DashboardEventCard.vue?vue&type=template&id=82106c48"
import script from "./DashboardEventCard.vue?vue&type=script&lang=js"
export * from "./DashboardEventCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports